import { render, staticRenderFns } from "./donation-link.vue?vue&type=template&id=3a941234&"
var script = {}
import style0 from "./donation-link.vue?vue&type=style&index=0&id=3a941234&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports